import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    telegramGroupsAdminControllerCreateTelegramGroupV1: build.mutation<
      TelegramGroupsAdminControllerCreateTelegramGroupV1ApiResponse,
      TelegramGroupsAdminControllerCreateTelegramGroupV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups`,
        method: 'POST',
        body: queryArg.createTelegramGroupBody,
      }),
    }),
    telegramGroupsAdminControllerListTelegramGroupsV1: build.query<
      TelegramGroupsAdminControllerListTelegramGroupsV1ApiResponse,
      TelegramGroupsAdminControllerListTelegramGroupsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/telegram-groups` }),
    }),
    telegramGroupsAdminControllerGetTelegramGroupJobStatusV1: build.query<
      TelegramGroupsAdminControllerGetTelegramGroupJobStatusV1ApiResponse,
      TelegramGroupsAdminControllerGetTelegramGroupJobStatusV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/jobs/${queryArg.jobId}`,
      }),
    }),
    telegramGroupsAdminControllerGetTelegramGroupV1: build.query<
      TelegramGroupsAdminControllerGetTelegramGroupV1ApiResponse,
      TelegramGroupsAdminControllerGetTelegramGroupV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}`,
      }),
    }),
    telegramGroupsAdminControllerUpdateTelegramGroupV1: build.mutation<
      TelegramGroupsAdminControllerUpdateTelegramGroupV1ApiResponse,
      TelegramGroupsAdminControllerUpdateTelegramGroupV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateTelegramGroupBody,
      }),
    }),
    telegramGroupsAdminControllerDeleteTelegramGroupV1: build.mutation<
      TelegramGroupsAdminControllerDeleteTelegramGroupV1ApiResponse,
      TelegramGroupsAdminControllerDeleteTelegramGroupV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    telegramGroupsAdminControllerBulkArchiveTelegramGroupsV1: build.mutation<
      TelegramGroupsAdminControllerBulkArchiveTelegramGroupsV1ApiResponse,
      TelegramGroupsAdminControllerBulkArchiveTelegramGroupsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/bulk-archive`,
        method: 'POST',
        body: queryArg.bulkArchiveTelegramGroupsBody,
      }),
    }),
    telegramGroupsAdminControllerBulkDeleteTelegramGroupsV1: build.mutation<
      TelegramGroupsAdminControllerBulkDeleteTelegramGroupsV1ApiResponse,
      TelegramGroupsAdminControllerBulkDeleteTelegramGroupsV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/bulk-delete`,
        method: 'POST',
        body: queryArg.bulkDeleteTelegramGroupsBody,
      }),
    }),
    telegramGroupsAdminControllerBulkAddTelegramGroupMembersV1: build.mutation<
      TelegramGroupsAdminControllerBulkAddTelegramGroupMembersV1ApiResponse,
      TelegramGroupsAdminControllerBulkAddTelegramGroupMembersV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/bulk-add-members`,
        method: 'POST',
        body: queryArg.bulkAddTelegramGroupMembersBody,
      }),
    }),
    telegramGroupsAdminControllerBulkRemoveTelegramGroupMembersV1: build.mutation<
      TelegramGroupsAdminControllerBulkRemoveTelegramGroupMembersV1ApiResponse,
      TelegramGroupsAdminControllerBulkRemoveTelegramGroupMembersV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/bulk-remove-members`,
        method: 'POST',
        body: queryArg.bulkRemoveTelegramGroupMembersBody,
      }),
    }),
    telegramGroupsAdminControllerListTelegramGroupMembersV1: build.query<
      TelegramGroupsAdminControllerListTelegramGroupMembersV1ApiResponse,
      TelegramGroupsAdminControllerListTelegramGroupMembersV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}/members`,
      }),
    }),
    telegramGroupsAdminControllerAddTelegramGroupMembersV1: build.mutation<
      TelegramGroupsAdminControllerAddTelegramGroupMembersV1ApiResponse,
      TelegramGroupsAdminControllerAddTelegramGroupMembersV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}/members`,
        method: 'POST',
        body: queryArg.addTelegramGroupMembersBody,
      }),
    }),
    telegramGroupsAdminControllerRemoveTelegramGroupMembersV1: build.mutation<
      TelegramGroupsAdminControllerRemoveTelegramGroupMembersV1ApiResponse,
      TelegramGroupsAdminControllerRemoveTelegramGroupMembersV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}/members`,
        method: 'DELETE',
        body: queryArg.removeTelegramGroupMembersBody,
      }),
    }),
    telegramGroupsAdminControllerCreateTelegramGroupInviteLinkV1: build.mutation<
      TelegramGroupsAdminControllerCreateTelegramGroupInviteLinkV1ApiResponse,
      TelegramGroupsAdminControllerCreateTelegramGroupInviteLinkV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}/invite-link`,
        method: 'POST',
      }),
    }),
    telegramGroupsAdminControllerArchiveTelegramGroupV1: build.mutation<
      TelegramGroupsAdminControllerArchiveTelegramGroupV1ApiResponse,
      TelegramGroupsAdminControllerArchiveTelegramGroupV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}/archive`,
        method: 'POST',
        body: queryArg.archiveTelegramGroupBody,
      }),
    }),
    telegramGroupsAdminControllerChangeTelegramGroupBotV1: build.mutation<
      TelegramGroupsAdminControllerChangeTelegramGroupBotV1ApiResponse,
      TelegramGroupsAdminControllerChangeTelegramGroupBotV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/telegram-groups/${queryArg.id}/bot`,
        method: 'PUT',
        body: queryArg.changeTelegramGroupBotBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type TelegramGroupsAdminControllerCreateTelegramGroupV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ CreateTelegramGroupResponse;
export type TelegramGroupsAdminControllerCreateTelegramGroupV1ApiArg = {
  createTelegramGroupBody: CreateTelegramGroupBody;
};
export type TelegramGroupsAdminControllerListTelegramGroupsV1ApiResponse =
  /** status 200 Returns the list of Telegram groups */ ListTelegramGroupsResponse;
export type TelegramGroupsAdminControllerListTelegramGroupsV1ApiArg = void;
export type TelegramGroupsAdminControllerGetTelegramGroupJobStatusV1ApiResponse =
  /** status 200 Current status of the async job */ GetTelegramGroupJobStatusResponse;
export type TelegramGroupsAdminControllerGetTelegramGroupJobStatusV1ApiArg = {
  jobId: string;
};
export type TelegramGroupsAdminControllerGetTelegramGroupV1ApiResponse =
  /** status 200 Returns the Telegram group */ GetTelegramGroupResponse;
export type TelegramGroupsAdminControllerGetTelegramGroupV1ApiArg = {
  id: number;
};
export type TelegramGroupsAdminControllerUpdateTelegramGroupV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ UpdateTelegramGroupResponse;
export type TelegramGroupsAdminControllerUpdateTelegramGroupV1ApiArg = {
  id: number;
  updateTelegramGroupBody: UpdateTelegramGroupBody;
};
export type TelegramGroupsAdminControllerDeleteTelegramGroupV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ DeleteTelegramGroupResponse;
export type TelegramGroupsAdminControllerDeleteTelegramGroupV1ApiArg = {
  id: number;
};
export type TelegramGroupsAdminControllerBulkArchiveTelegramGroupsV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ BulkArchiveTelegramGroupsResponse;
export type TelegramGroupsAdminControllerBulkArchiveTelegramGroupsV1ApiArg = {
  bulkArchiveTelegramGroupsBody: BulkArchiveTelegramGroupsBody;
};
export type TelegramGroupsAdminControllerBulkDeleteTelegramGroupsV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ BulkDeleteTelegramGroupsResponse;
export type TelegramGroupsAdminControllerBulkDeleteTelegramGroupsV1ApiArg = {
  bulkDeleteTelegramGroupsBody: BulkDeleteTelegramGroupsBody;
};
export type TelegramGroupsAdminControllerBulkAddTelegramGroupMembersV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ BulkAddTelegramGroupMembersResponse;
export type TelegramGroupsAdminControllerBulkAddTelegramGroupMembersV1ApiArg = {
  bulkAddTelegramGroupMembersBody: BulkAddTelegramGroupMembersBody;
};
export type TelegramGroupsAdminControllerBulkRemoveTelegramGroupMembersV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ BulkRemoveTelegramGroupMembersResponse;
export type TelegramGroupsAdminControllerBulkRemoveTelegramGroupMembersV1ApiArg = {
  bulkRemoveTelegramGroupMembersBody: BulkRemoveTelegramGroupMembersBody;
};
export type TelegramGroupsAdminControllerListTelegramGroupMembersV1ApiResponse =
  /** status 200 Returns the group's current Telegram members */ ListTelegramGroupMembersResponse;
export type TelegramGroupsAdminControllerListTelegramGroupMembersV1ApiArg = {
  id: number;
};
export type TelegramGroupsAdminControllerAddTelegramGroupMembersV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ AddTelegramGroupMembersResponse;
export type TelegramGroupsAdminControllerAddTelegramGroupMembersV1ApiArg = {
  id: number;
  addTelegramGroupMembersBody: AddTelegramGroupMembersBody;
};
export type TelegramGroupsAdminControllerRemoveTelegramGroupMembersV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ RemoveTelegramGroupMembersResponse;
export type TelegramGroupsAdminControllerRemoveTelegramGroupMembersV1ApiArg = {
  id: number;
  removeTelegramGroupMembersBody: RemoveTelegramGroupMembersBody;
};
export type TelegramGroupsAdminControllerCreateTelegramGroupInviteLinkV1ApiResponse =
  /** status 201 The freshly minted invite link */ CreateTelegramGroupInviteLinkResponse;
export type TelegramGroupsAdminControllerCreateTelegramGroupInviteLinkV1ApiArg = {
  id: number;
};
export type TelegramGroupsAdminControllerArchiveTelegramGroupV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ ArchiveTelegramGroupResponse;
export type TelegramGroupsAdminControllerArchiveTelegramGroupV1ApiArg = {
  id: number;
  archiveTelegramGroupBody: ArchiveTelegramGroupBody;
};
export type TelegramGroupsAdminControllerChangeTelegramGroupBotV1ApiResponse =
  /** status 202 Accepted; returns the job id to track completion */ ChangeTelegramGroupBotResponse;
export type TelegramGroupsAdminControllerChangeTelegramGroupBotV1ApiArg = {
  id: number;
  changeTelegramGroupBotBody: ChangeTelegramGroupBotBody;
};
export type CreateTelegramGroupResponse = {
  jobId: string;
};
export type CreateTelegramGroupBody =
  | {
      type: 'STANDARD';
      /** Telegram group title */
      groupName: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) exchange API public key */
      publicKey: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) exchange API secret key */
      secretKey: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) exchange API passphrase */
      passphrase?: string;
      /** Loan identifier */
      loanName?: string;
      /** Exchange sub-account label */
      subAccount?: string;
      /** Trading bot to attach, overriding the recommended one (from GET /admin/trading-bots) */
      botUsername?: string;
    }
  | {
      type: 'DEEP_LIQUIDITY';
      /** Telegram group title */
      groupName: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) exchange API public key */
      publicKey: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) exchange API secret key */
      secretKey: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) exchange API passphrase */
      passphrase?: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) second exchange API public key */
      publicKey2?: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) second exchange API secret key */
      secretKey2?: string;
      /** Base64 RSA-encrypted (PKCS#1 v1.5) second exchange API passphrase */
      passphrase2?: string;
      /** HFT region (0: Retainer, 1: US-1, 2: HongKong-1, 3: Japan-1) */
      region: number;
      /** Loan identifier */
      loanName?: string;
      /** Exchange sub-account label */
      subAccount?: string;
      /** Trading bot to attach, overriding the recommended one (from GET /admin/trading-bots) */
      botUsername?: string;
    }
  | {
      type: 'NO_KEYS';
      /** Telegram group title */
      groupName: string;
      /** Trading bot to attach, overriding the recommended one (from GET /admin/trading-bots) */
      botUsername?: string;
    };
export type ListTelegramGroupsResponse = {
  /** Telegram Group record ID */
  id: number;
  /** Telegram chat ID (negative for basic groups) */
  chatId: string;
  /** Group number extracted from the title (unique) */
  groupNumber: string;
  /** Telegram group title */
  title: string;
  /** Username of the Skynet bot added to the group */
  botUsername: null | string;
  /** Group status (0 = archived, 1 = active) */
  status: number;
  /** Whose exchange account the group runs on */
  accountType: 'OUR' | 'CLIENT' | 'NONE';
  /** Name of the user who created the group */
  createdBy: null | string;
  /** Optional freeform comment */
  comment: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** Last update timestamp */
  updatedAt: string;
  /** Name of the user who last updated the group */
  updatedBy: null | string;
}[];
export type GetTelegramGroupJobStatusResponse = {
  id: string;
  name: string;
  state: 'waiting' | 'active' | 'delayed' | 'completed' | 'failed' | 'unknown';
  progress?: any;
  returnValue?: any;
  failedReason?: string;
  code?: string;
  initiatorId?: number;
  attemptsMade: number;
  timestamp?: number;
  processedOn?: number;
  finishedOn?: number;
};
export type GetTelegramGroupResponse = {
  /** Telegram Group record ID */
  id: number;
  /** Telegram chat ID (negative for basic groups) */
  chatId: string;
  /** Group number extracted from the title (unique) */
  groupNumber: string;
  /** Telegram group title */
  title: string;
  /** Username of the Skynet bot added to the group */
  botUsername: null | string;
  /** Group status (0 = archived, 1 = active) */
  status: number;
  /** Whose exchange account the group runs on */
  accountType: 'OUR' | 'CLIENT' | 'NONE';
  /** Name of the user who created the group */
  createdBy: null | string;
  /** Optional freeform comment */
  comment: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** Last update timestamp */
  updatedAt: string;
  /** Name of the user who last updated the group */
  updatedBy: null | string;
};
export type UpdateTelegramGroupResponse = {
  jobId: string;
};
export type UpdateTelegramGroupBody = {
  /** Telegram group title */
  title?: string;
  /** Optional freeform comment */
  comment?: null | string;
  /** Whose exchange account the group runs on */
  accountType?: 'OUR' | 'CLIENT' | 'NONE';
};
export type DeleteTelegramGroupResponse = {
  jobId: string;
};
export type BulkArchiveTelegramGroupsResponse = {
  jobId: string;
};
export type BulkArchiveTelegramGroupsBody = {
  /** Telegram group ids to act on */
  ids: number[];
  force?: boolean;
};
export type BulkDeleteTelegramGroupsResponse = {
  jobId: string;
};
export type BulkDeleteTelegramGroupsBody = {
  /** Telegram group ids to act on */
  ids: number[];
};
export type BulkAddTelegramGroupMembersResponse = {
  jobId: string;
};
export type BulkAddTelegramGroupMembersBody = {
  /** Telegram group ids to act on */
  groupIds?: number[];
  /** Target every group with this status instead of listing ids; archived and all also opt into changing archived groups */
  scope?: 'active' | 'archived' | 'all';
  /** Auth user ids to add to / remove from the group(s) */
  userIds: number[];
  /** Auth user list to resolve userIds against; inferred from the group name when omitted */
  domain?: 'loans' | 'retainers';
};
export type BulkRemoveTelegramGroupMembersResponse = {
  jobId: string;
};
export type BulkRemoveTelegramGroupMembersBody = {
  /** Telegram group ids to act on */
  groupIds?: number[];
  /** Target every group with this status instead of listing ids; archived and all also opt into changing archived groups */
  scope?: 'active' | 'archived' | 'all';
  /** Auth user ids to add to / remove from the group(s) */
  userIds: number[];
  /** Auth user list to resolve userIds against; inferred from the group name when omitted */
  domain?: 'loans' | 'retainers';
};
export type ListTelegramGroupMembersResponse = {
  telegramUserId: number;
  /** Member's standing in the group */
  status: 'creator' | 'admin' | 'member' | 'restricted' | 'banned' | 'left';
  username: string | null;
  isBot: boolean;
  isSelf: boolean;
}[];
export type AddTelegramGroupMembersResponse = {
  jobId: string;
};
export type AddTelegramGroupMembersBody = {
  /** Auth user ids to add to / remove from the group(s) */
  userIds: number[];
  /** Auth user list to resolve userIds against; inferred from the group name when omitted */
  domain?: 'loans' | 'retainers';
};
export type RemoveTelegramGroupMembersResponse = {
  jobId: string;
};
export type RemoveTelegramGroupMembersBody = {
  /** Auth user ids to add to / remove from the group(s) */
  userIds: number[];
  /** Auth user list to resolve userIds against; inferred from the group name when omitted */
  domain?: 'loans' | 'retainers';
};
export type CreateTelegramGroupInviteLinkResponse = {
  /** The minted invite link */
  inviteLink: string;
  /** When Telegram will stop accepting the link; null if it applied no expiry */
  expiresAt: string | null;
  /** How many people may be in the chat at the same time via this link (Telegram counts concurrent members, not total joins); null if it applied no limit */
  usageLimit: number | null;
  /** True when Telegram handed back the group's PERMANENT link instead of minting a new one. Such a link is durable and must not be presented as single-use. */
  isPrimary: boolean;
};
export type ArchiveTelegramGroupResponse = {
  jobId: string;
};
export type ArchiveTelegramGroupBody = {
  force?: boolean;
};
export type ChangeTelegramGroupBotResponse = {
  jobId: string;
};
export type ChangeTelegramGroupBotBody = {
  /** Trading bot to attach, as listed by GET /admin/trading-bots (without the leading @) */
  botUsername: string;
};
